import * as React from 'react';

import { StyleSheet, css } from '@coursera/coursera-ui';

import { ProficiencyLevels } from 'bundles/enterprise-admin-skills/svg';
import { SkillLevels, getSkillRangeLabels } from 'bundles/enterprise-admin-skills/utils/skillTargets';

const styles = StyleSheet.create({
  container: {
    width: 345,
  },
  levelLabel: {
    color: '#888888',
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  legendContainer: {
    marginTop: 20,
  },
  legendText: {
    fontSize: 14,
    lineHeight: '24px',
    backgroundColor: '#F7F7F7',
    padding: '0 12px',
    marginBottom: 0,
  },
  legendLevel: {
    color: '#666666',
    width: '100%',
  },
  legendRow: {
    marginTop: 4,
  },
  legendRange: {
    fontWeight: 'bold',
    textAlign: 'right',
    marginRight: 4,
    minWidth: 84,
    maxWidth: 84,
  },
});

const LegendRow: React.FC<{ skillLevel: SkillLevels; color: string }> = ({ skillLevel, color }) => {
  const { range, level } = getSkillRangeLabels()[skillLevel];
  return (
    <div {...css(styles.legendRow, 'horizontal-box')}>
      <p {...css(styles.legendText, styles.legendRange)} style={{ color }}>
        {range}
      </p>
      <p {...css(styles.legendText, styles.legendLevel)}>{level}</p>
    </div>
  );
};

const ProficiencyLevelsInfoGraph: React.FC<{}> = () => (
  <div {...css(styles.container, 'vertical-box')}>
    <ProficiencyLevels />
    <div {...css(styles.legendContainer, 'vertical-box')}>
      <LegendRow skillLevel={SkillLevels.conversant} color="#BDBDBD" />
      <LegendRow skillLevel={SkillLevels.beginner} color="#888888" />
      <LegendRow skillLevel={SkillLevels.intermediate} color="#595959" />
      <LegendRow skillLevel={SkillLevels.advanced} color="#1F1F1F" />
    </div>
  </div>
);

export default ProficiencyLevelsInfoGraph;
